import type { JSX } from "react";
import { seasonOf, type Season } from "./season";
export function Horizon(p: { variant: "hero" | "header" | "center"; season?: Season; className?: string }): JSX.Element {
  return <img aria-hidden="true" alt="" width={1440} height={360} className={`qy-horizon qy-horizon--${p.variant} ${p.className ?? ""}`} src={`/tianguang/horizon-${p.season ?? seasonOf(new Date())}.svg`} />;
}
